module.exports = __webpack_public_path__ + "img/lanqiu.b5177d31.png";